import React, { useEffect, useState, useCallback } from 'react';
import * as ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import c from 'classnames';
import styles from './Item.css';

import { MediaItem } from './ItemMedia';
import { ItemSummaryFooter } from './ItemSummary';

import { selectHighlightViewed, selectIsCardsView } from '../../ducks';
import { ItemDescription } from './ItemDescription';

const fireGAEvent = (action, label) => ReactGA.event({
  category: 'Item Click',
  action,
  label,
});

const itemClickGAEvent = (item, isSidebar, isToppers) => fireGAEvent(
  `${
    c({
      ['Nsfa']: item.nopreroll,
      ['Nsfw']: item.nsfw,
      ['Image']: item.media.length !== 0 &&
      item.media[0].mediatype === 'FOTO' &&
      !item.nsfw && !isSidebar && !item.nopreroll,
      ['Video']: item.media.length !== 0 &&
      item.media[0].mediatype === 'VIDEO' &&
      !item.nsfw && !isSidebar && !item.nopreroll,
      ['Top 5']: isSidebar && isToppers && !item.nsfw && !item.nopreroll,
      ['DumpertTV']: !isToppers && isSidebar,
    })} Item Click`,
  item.nsfw ? item.media[0].mediatype === 'FOTO' ? 'Image' : 'Video' : item.title,
);
const storeItemClickGAEvent = title => fireGAEvent('DumpertWinkel Item Click', title);

const ItemFill = ({
  item,
  isToppers,
  counter,
  isSidebar,
  isStoreItem,
  highlightViewed,
  highlightMedia,
  showDescription,
}) => (
  <>
    <MediaItem
      item={item}
      isToppers={isToppers}
      counter={counter}
      isSidebar={isSidebar}
      isStoreItem={isStoreItem}
      highlight={highlightViewed && highlightMedia}
    />
    <div className={styles.summary}>
      {!showDescription && (
        <>
          <div className={c(styles.desc, styles.desc_placeholder)}>
            <div>
              <h3 className="title">&nbsp;</h3>
              <p className={styles.description}>&nbsp;</p>
            </div>
            <p className={c(styles.description, styles.bottom)}>&nbsp;</p>
          </div>
        </>
      )}
      {showDescription && <>
        <ItemDescription item={item}/>
        <ItemSummaryFooter item={item} isStoreItem={isStoreItem}/>
      </>}
    </div>
  </>
);

export const ItemLink = ({
  item,
  isToppers,
  isStoreItem,
  highlightViewed,
  highlightMedia,
  counter,
  showDescription,
  onClick,
  isSidebar,
  isCardsView,
  isModalRelatedItem,
  isSearchTagPage,
}) => {

  const history = useHistory();
  const clickHandler = useCallback((e) => {
    e.preventDefault();
    if (e.ctrlKey || e.metaKey) {
      window.open(`/item/${item.id}`, '_blank', 'noopener, noreferrer');
    } else {
      const href = () => isModalRelatedItem || isModalRelatedItem !== false && !isSearchTagPage
        ? ({ search: `?selectedId=${item.id}`})
        : ({ pathname: `/item/${item.id}`});
      history.push({ ...href() });
    }
    onClick();
  }, [onClick, item.id, isModalRelatedItem, isModalRelatedItem]);
  return (
    <a
      onClick={clickHandler}
      href={`/item/${item.id}`}
      rel="noopener noreferrer"
      className={c(
        styles.item,
        'grid-item',
        {
          [styles.card]: isCardsView && !isSidebar,
          [styles.list]: !isCardsView || isSidebar,
          ['sidebar_item']: isSidebar,
        })}
    >
      <ItemFill
        item={item}
        isToppers={isToppers}
        counter={counter}
        isSidebar={isSidebar}
        isStoreItem={isStoreItem}
        highlightViewed={highlightViewed}
        highlightMedia={highlightMedia}
        showDescription={showDescription}
      />
    </a>);
};

export const Item = ({
  item,
  isSidebar,
  isToppers,
  isStoreItem,
  counter,
  isModalRelatedItem,
  isSearchTagPage,
}) => {

  const isCardsView = useSelector(selectIsCardsView);
  const [showDescription, setShowDescription] = useState(false);
  const [highlightMedia, setHighlightMedia] = useState(false);
  const highlightViewed = useSelector(selectHighlightViewed);
  const itemClickHandler = useCallback(
    () => itemClickGAEvent(item, isSidebar, isToppers),
    [item.id, isSidebar, isToppers]);
  const storeItemClickHandler = useCallback(
    () => storeItemClickGAEvent(item.title),
    [item.title],
  );

  // description shouldn't be be rendered on server because of it's useLayoutEffect
  // https://reactjs.org/docs/hooks-reference.html#uselayouteffect
  useEffect(() => {
    setShowDescription(true);
  }, []);

  useEffect(() => {
    try {
      setHighlightMedia(
        (window.sessionStorage.getItem('viewedItems') || '')
          .split(',')
          .includes(item.id),
      );
    } catch (e) {

      // no-op
    }
  });

  return (
    <>
      {isStoreItem && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={item.store_data.link}
          onClick={storeItemClickHandler}
          className={c(
            styles.item,
            'grid-item',
            {
              [styles.list]: !isCardsView || isSidebar,
              [styles.sidebar_item]: isSidebar,
            })}
        >
          <ItemFill
            item={item}
            isToppers={isToppers}
            counter={counter}
            isSidebar={isSidebar}
            isStoreItem={isStoreItem}
            highlightViewed={highlightViewed}
            highlightMedia={highlightMedia}
            showDescription={showDescription}
          />
        </a>
      )}
      {!isStoreItem && 
        <ItemLink
          item={item}
          isSidebar={isSidebar}
          isCardsView={isCardsView}
          onClick={itemClickHandler}
          isToppers={isToppers}
          isStoreItem={isStoreItem}
          highlightViewed={highlightViewed}
          highlightMedia={highlightMedia}
          counter={counter}
          showDescription={showDescription}
          isModalRelatedItem={isModalRelatedItem}
          isSearchTagPage={isSearchTagPage}
        />
      }
    </>
  );
};
